var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _rect2, _rect3, _rect4, _path9, _rect5, _rect6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationHourglass(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 301,
    height: 200,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5F9",
    fillRule: "evenodd",
    d: "M275.143 115.034c15.001 40.123-66.536 76.964-103.139 80.103-36.498 3.297-104.298 7.92-150.582-43.467C-24.731 100.094 7.98 7.24 112.184 46.314c104.287 39.184 148.051 28.727 162.959 68.72Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 277,
    height: 161,
    x: 0,
    y: 36,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M275.143 115.034c15.001 40.123-66.536 76.964-103.139 80.103-36.498 3.297-104.298 7.92-150.582-43.467C-24.731 100.094 7.98 7.24 112.184 46.314c104.287 39.184 148.051 28.727 162.959 68.72Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF2",
    d: "M-8.758 139h83.696A2.06 2.06 0 0 1 77 141.06v57.88a2.06 2.06 0 0 1-2.062 2.06H-8.758a2.06 2.06 0 0 1-2.061-2.06v-57.88A2.06 2.06 0 0 1-8.758 139Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    d: "M-34.938 148.269h100.6a2.06 2.06 0 0 1 2.061 2.06v26.777a2.06 2.06 0 0 1-2.061 2.06h-100.6a2.06 2.06 0 0 1-2.062-2.06v-26.777a2.06 2.06 0 0 1 2.062-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF2",
    d: "M203.061 139h83.697a2.06 2.06 0 0 1 2.061 2.06v57.88a2.06 2.06 0 0 1-2.061 2.06h-83.697a2.06 2.06 0 0 1-2.061-2.06v-57.88a2.06 2.06 0 0 1 2.061-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    d: "M212.338 148.269h100.601a2.06 2.06 0 0 1 2.061 2.06v26.777a2.06 2.06 0 0 1-2.061 2.06H212.338a2.06 2.06 0 0 1-2.061-2.06v-26.777a2.06 2.06 0 0 1 2.061-2.06ZM80.057 121h118.886c1.136 0 2.057.929 2.057 2.074v107.852a2.066 2.066 0 0 1-2.057 2.074H80.057A2.066 2.066 0 0 1 78 230.926V123.074c0-1.145.92-2.074 2.057-2.074Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF2",
    d: "M89.313 130.333h100.374c1.136 0 2.057.929 2.057 2.075v26.963a2.066 2.066 0 0 1-2.057 2.074H89.313a2.066 2.066 0 0 1-2.057-2.074v-26.963c0-1.146.92-2.075 2.057-2.075Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    d: "M139.5 150.452c2.499 0 4.525-2.043 4.525-4.563 0-2.52-2.026-4.563-4.525-4.563-2.499 0-4.525 2.043-4.525 4.563 0 2.52 2.026 4.563 4.525 4.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF2",
    d: "M89.313 167.667h100.374c1.136 0 2.057.928 2.057 2.074v26.963a2.066 2.066 0 0 1-2.057 2.074H89.313a2.066 2.066 0 0 1-2.057-2.074v-26.963c0-1.146.92-2.074 2.057-2.074Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    d: "M139.5 187.785c2.499 0 4.525-2.043 4.525-4.563 0-2.52-2.026-4.563-4.525-4.563-2.499 0-4.525 2.043-4.525 4.563 0 2.52 2.026 4.563 4.525 4.563Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    d: "M111.148 11h3.704v99h-3.704zM152.148 11h3.704v99h-3.704z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5F9",
    fillOpacity: 0.835,
    fillRule: "evenodd",
    d: "M120 11h43v26.634c0 4.733-2.874 8.998-7.28 10.806-6.927 2.843-10.391 6.52-10.391 11.032 0 4.687 3.737 8.907 11.211 12.662 3.962 1.991 6.46 6.025 6.46 10.433V110h-43V82.468c0-4.373 2.458-8.38 6.372-10.388 7.533-3.864 11.299-8.067 11.299-12.608 0-4.373-3.493-8.026-10.479-10.96-4.359-1.829-7.192-6.07-7.192-10.768V11Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    d: "M120 11h43v26.634c0 4.733-2.874 8.998-7.28 10.806-6.927 2.843-10.391 6.52-10.391 11.032 0 4.687 3.737 8.907 11.211 12.662 3.962 1.991 6.46 6.025 6.46 10.433V110h-43V82.468c0-4.373 2.458-8.38 6.372-10.388 7.533-3.864 11.299-8.067 11.299-12.608 0-4.373-3.493-8.026-10.479-10.96-4.359-1.829-7.192-6.07-7.192-10.768V11Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00DB2E",
    fillRule: "evenodd",
    d: "M160 105a3 3 0 0 1-3 3h-31a3 3 0 0 1-3-3V84.59a3 3 0 0 1 1.133-2.347l12.828-10.202a6 6 0 0 1 7.22-.188l14.562 10.393A3 3 0 0 1 160 84.688V105Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "evenodd",
    d: "M160 105a3 3 0 0 1-3 3h-31a3 3 0 0 1-3-3V84.59a3 3 0 0 1 1.133-2.347l12.828-10.202a6 6 0 0 1 7.22-.188l14.562 10.393A3 3 0 0 1 160 84.688V105Z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 14,
    x: 123,
    y: 16,
    fill: "#fff",
    opacity: 0.3,
    rx: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    d: "M125.148 11h3.704v99h-3.704z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 5,
    x: 123,
    y: 30,
    fill: "#fff",
    opacity: 0.3,
    rx: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 5,
    x: 150,
    y: 82,
    fill: "#fff",
    opacity: 0.3,
    rx: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 15,
    fill: "#fff",
    opacity: 0.3,
    rx: 3,
    transform: "matrix(1 0 0 -1 150 105)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    d: "M166.148 11h3.704v99h-3.704z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 7,
    x: 104,
    y: 110,
    fill: "#303C4B",
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 7,
    x: 104,
    y: 4,
    fill: "#303C4B",
    rx: 1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 98.041,
    x2: 171.45,
    y1: 58.386,
    y2: 90.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F9",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403F9F",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 104.105,
    x2: 142.874,
    y1: 87.785,
    y2: 125.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F9",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403F9F",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationHourglass);
export default __webpack_public_path__ + "static/media/illustration-hourglass.2b243b19b88f2af616880eaadd9d74b2.svg";
export { ForwardRef as ReactComponent };